export default {
  title: 'Resetați parola',
  description: 'Vom trimite un link de resetare a parolei pe e-mailul dvs.',
  sent: 'E-mailul a fost trimis.',

  form: {
    email: {
      title: 'E-mail',
      placeholder: 'Introduceți e-mailul',
    },
    button: {
      title: 'Resetați parola',
    },
    error_messages: {
      error1: 'Informații lipsă',
    },
  },
};
